<!--
  Nothing open in panel 3: no Related band (stitch-app-shell skin), so the knowledge half shrinks to its
  tabs and the results take the panel; the half's saved height comes back with the next open item.
-->
<app-split-view
  [class.kp-nothing-open]="nothingOpen()"
  side="left"
  direction="vertical"
  key="kp"
  [collapsedSize]="42"
  [shadow]="true"
  [magneticSize]="120"
  [extraSize]="selectedRowHeight()"
  >
  <div split-left-pane class="split-area">
    <!-- SBUX-951's search wraps the tab row (its toggle at the row's end); the tabs take the skin's look. -->
    <app-kp-search splitKey="kp">
      <app-tabs
        class="flex-1"
        appearance="sapphire"
        size="s"
        selectedStateKey="kpTabs"
        [values]="tabsValues"
        [value]="currentTab"
        (valueChange)="handleTabsChange($event)"
        />
    </app-kp-search>

    <app-filters-panel />

    @if (currentTab === 'tags') {
      <app-tags-knowledge-section class="min-h-0 flex-1" />
    }

    @if (currentTab === 'knots') {
      <app-knots-knowledge-section class="min-h-0 flex-1" />
    }

    @if (currentTab === 'connections') {
      <app-connections-knowledge-section class="min-h-0 flex-1" />
    }
  </div>

  <div split-right-pane class="split-area">
    @switch (kpListType()) {
      @case (KPListType.calendar) {
        <app-knowledge-calendars-section
          *appCalendarAppContext
          [stateKey]="resultsTypeStateKey"
          [tags]="resultsTags()"
          [knots]="resultsKnots()"
          [type]="kpListType()"
          [connections]="resultsConnections()"
          (itemClick)="handleClickItem($event)"
          (typeChange)="kpListType.set($event)"
        />
      }
      @case (KPListType.contact) {
        <app-knowledge-contacts-section
          *appContactsAppContext
          [stateKey]="resultsTypeStateKey"
          [tags]="resultsTags()"
          [knots]="resultsKnots()"
          [type]="kpListType()"
          [connections]="resultsConnections()"
          (itemClick)="handleClickItem($event)"
          (typeChange)="kpListType.set($event)"
        />
      }
      @case (KPListType.event) {
        <app-knowledge-events-section
          *appCalendarAppContext
          [stateKey]="resultsTypeStateKey"
          [tags]="resultsTags()"
          [knots]="resultsKnots()"
          [type]="kpListType()"
          [connections]="resultsConnections()"
          (itemClick)="handleClickItem($event)"
          (typeChange)="kpListType.set($event)"
        />
      }
      @case (KPListType.file) {
        <app-knowledge-files-section
          *appFilesAppContext
          [stateKey]="resultsTypeStateKey"
          [tags]="resultsTags()"
          [knots]="resultsKnots()"
          [type]="kpListType()"
          [connections]="resultsConnections()"
          (itemClick)="handleClickItem($event)"
          (typeChange)="kpListType.set($event)"
        />
      }
      @case (KPListType.folder) {
        <app-knowledge-folders-section
          *appFilesAppContext
          [stateKey]="resultsTypeStateKey"
          [tags]="resultsTags()"
          [knots]="resultsKnots()"
          [type]="kpListType()"
          [connections]="resultsConnections()"
          (itemClick)="handleClickItem($event)"
          (typeChange)="kpListType.set($event)"
        />
      }
      @case (KPListType.sheetFolder) {
        <app-knowledge-sheet-folders-section
          *appSheetsAppContext
          [stateKey]="resultsTypeStateKey"
          [tags]="resultsTags()"
          [knots]="resultsKnots()"
          [type]="kpListType()"
          [connections]="resultsConnections()"
          (itemClick)="handleClickItem($event)"
          (typeChange)="kpListType.set($event)"
        />
      }
      @case (KPListType.sheet) {
        <app-knowledge-sheets-section
          *appSheetsAppContext
          [stateKey]="resultsTypeStateKey"
          [tags]="resultsTags()"
          [knots]="resultsKnots()"
          [type]="kpListType()"
          [connections]="resultsConnections()"
          (itemClick)="handleClickItem($event)"
          (typeChange)="kpListType.set($event)"
        />
      }
      @case (KPListType.group) {
        <app-knowledge-groups-section
          *appContactsAppContext
          [stateKey]="resultsTypeStateKey"
          [tags]="resultsTags()"
          [knots]="resultsKnots()"
          [type]="kpListType()"
          [connections]="resultsConnections()"
          (itemClick)="handleClickItem($event)"
          (typeChange)="kpListType.set($event)"
        />
      }
      @case (KPListType.messageFolder) {
        <app-knowledge-mail-folders-section
          *appMailAppContext
          [stateKey]="resultsTypeStateKey"
          [tags]="resultsTags()"
          [knots]="resultsKnots()"
          [type]="kpListType()"
          [connections]="resultsConnections()"
          (itemClick)="handleClickItem($event)"
          (typeChange)="kpListType.set($event)"
        />
      }
      @case (KPListType.message) {
        <app-knowledge-messages-section
          *appMailAppContext
          [stateKey]="resultsTypeStateKey"
          [tags]="resultsTags()"
          [knots]="resultsKnots()"
          [type]="kpListType()"
          [connections]="resultsConnections()"
          (itemClick)="handleClickItem($event)"
          (typeChange)="kpListType.set($event)"
        />
      }
      @case (KPListType.notebook) {
        <app-knowledge-notebooks-section
          *appNotesAppContext
          [stateKey]="resultsTypeStateKey"
          [tags]="resultsTags()"
          [knots]="resultsKnots()"
          [type]="kpListType()"
          [connections]="resultsConnections()"
          (itemClick)="handleClickItem($event)"
          (typeChange)="kpListType.set($event)"
        />
      }
      @case (KPListType.note) {
        <app-knowledge-notes-section
          *appNotesAppContext
          [stateKey]="resultsTypeStateKey"
          [tags]="resultsTags()"
          [knots]="resultsKnots()"
          [type]="kpListType()"
          [connections]="resultsConnections()"
          (itemClick)="handleClickItem($event)"
          (typeChange)="kpListType.set($event)"
        />
      }
      @case (KPListType.project) {
        <app-knowledge-projects-section
          *appTaskingAppContext
          [stateKey]="resultsTypeStateKey"
          [tags]="resultsTags()"
          [knots]="resultsKnots()"
          [type]="kpListType()"
          [connections]="resultsConnections()"
          (itemClick)="handleClickItem($event)"
          (typeChange)="kpListType.set($event)"
        />
      }
      @case (KPListType.task) {
        <app-knowledge-tasks-section
          *appTaskingAppContext
          [stateKey]="resultsTypeStateKey"
          [tags]="resultsTags()"
          [knots]="resultsKnots()"
          [type]="kpListType()"
          [connections]="resultsConnections()"
          (itemClick)="handleClickItem($event)"
          (typeChange)="kpListType.set($event)"
        />
      }
    }
  </div>
  </app-split-view>
